import { TestTube, Activity, Droplet, ClipboardList, FlaskConical, Hourglass } from 'lucide-react';

// Companion app add-on referenced across services
export const COMPANION_ADDON = {
  name: 'Rejuven wellness companion app',
  desc: 'Optional add-on: 24/7 access to the Rejuven wellness companion app for personalized, educational guidance between check-ins.',
};

export const services = [
  {
    slug: 'microbiome-package',
    title: 'Microbiome Package',
    icon: TestTube,
    image: 'https://images.unsplash.com/photo-1631824687534-f642fc820d54?w=900&q=85&auto=format&fit=crop',
    tagline: 'A complete look inside your biology',
    intro: "A full microbiome analysis powered by Viome's gut, oral and blood testing kits. We turn your results into clear, personalized and preventative guidance — so you finally understand what your body is telling you.",
    walkthrough: [
      { icon: ClipboardList, title: 'Order & onboard', desc: 'Join the beta and complete a short health & goals questionnaire so we can tailor your analysis.' },
      { icon: TestTube, title: 'Collect your samples', desc: 'Your Viome gut, oral and blood kits arrive at home with simple, guided collection steps.' },
      { icon: Activity, title: 'Ship to the lab', desc: 'Use the prepaid packaging to send your samples to Viome for sequencing — no clinic visit needed.' },
      { icon: FlaskConical, title: 'Analysis', desc: 'Viome analyzes your gut, oral and blood biology; Rejuven interprets the results for your goals.' },
      { icon: Droplet, title: 'Your personalized plan', desc: 'Receive clear, preventative nutrition and lifestyle guidance mapped to your unique biology.' },
    ],
  },
  {
    slug: 'longevity-program',
    title: 'Personalized Longevity & Wellness Program',
    icon: Hourglass,
    image: 'https://images.unsplash.com/photo-1567013514336-6de53c9e7e63?w=900&q=85&auto=format&fit=crop',
    tagline: 'Ongoing guidance built around your focus',
    intro: 'An ongoing, personalized program built around the focus area that matters most to you — from fertility to menopause to longevity. Preventative guidance that evolves with your biology and goals.',
    walkthrough: null,
  },
];

export const getServiceBySlug = (slug) => services.find((s) => s.slug === slug);
